/* globals */
import { useEffect } from 'react';
import { debounce } from '@sainsburys-tech/boltui-utils';
/**
 * @param {object} param
 * @param {boolean=} param.isEnabled - when true, resizeHandler callback will be triggered upon the window being resized (default=true)
 * @param {function} param.resizeHandler - callback to be run upon the window being resized
 * @param {number=} param.debounceDelay - debounce delay (default=100)
 * */

var useResizeEvent = function useResizeEvent(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      resizeHandler = _ref.resizeHandler,
      _ref$debounceDelay = _ref.debounceDelay,
      debounceDelay = _ref$debounceDelay === void 0 ? 100 : _ref$debounceDelay;
  var handleResize = debounce(resizeHandler, debounceDelay);
  useEffect(function () {
    if (isEnabled) {
      window.addEventListener('resize', handleResize);
    }

    return function () {
      if (isEnabled) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [isEnabled]);
};

export default useResizeEvent;